export const firebaseConfig = {
  apiKey: "AIzaSyAcRj1jM8NpPSBmjDPLHbIlovgqvWcpAt0",
  authDomain: "book-store-1856c.firebaseapp.com",
  projectId: "book-store-1856c",
  storageBucket: "book-store-1856c.appspot.com",
  messagingSenderId: "669052223184",
  appId: "1:669052223184:web:05a6f1ccd62ad2521b28d5",
};
